import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { useLocale } from 'next-intl';
import { memo } from 'react';
import { useCurrency } from '@/contexts/CurrencyContext';
const FormattedPrice = memo(function FormattedPrice({ value, currency, compactThreshold = 10000, decimals = 2, noCurrency = false, showDoubleZeros = false, rawString, }) {
    const { selectedCurrency } = useCurrency();
    const locale = useLocale();
    if (!value)
        return null;
    const formatCompactPrice = (amount) => {
        return new Intl.NumberFormat(locale, {
            style: noCurrency ? 'decimal' : 'currency',
            currency: currency || selectedCurrency,
            notation: amount > compactThreshold ? 'compact' : 'standard',
            compactDisplay: 'short',
            currencyDisplay: 'symbol',
            minimumFractionDigits: showDoubleZeros ? 2 : 0,
            maximumFractionDigits: amount < compactThreshold ? (showDoubleZeros ? 2 : 0) : decimals,
        }).format(amount);
    };
    return (rawString
        ? formatCompactPrice(Number(value))
        : (_jsx(Typography, { component: "span", sx: { fontSize: 'inherit', fontWeight: 'inherit' }, children: formatCompactPrice(Number(value)) })));
});
export default FormattedPrice;
